import React from "react";
import { FaGraduationCap } from "react-icons/fa";
import "./DemoRegistrationTab.css";

const DemoRegistrationTab = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Register for the free 3-day demo class"
      className="demo-reg-banner relative w-full
                 bg-[#1B1F3B] text-[#FDFBF7] shadow-2xl
                 border-t border-[#F4A340]/40
                 hover:bg-[#242a52] transition-colors duration-300
                 focus:outline-none overflow-hidden"
    >
      <div className="demo-marquee-track flex items-center whitespace-nowrap py-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <span
            key={i}
            className="flex items-center gap-2 mx-8 text-xs font-bold uppercase tracking-wide"
          >
            <FaGraduationCap
              size={18}
              className="text-[#F4A340] flex-shrink-0"
            />
            Free 3-Day Demo Class &mdash; Register Now
          </span>
        ))}
      </div>
    </button>
  );
};

export default DemoRegistrationTab;
